import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Feedback } from '@/types/feedback';

import ContentModal from './ContentModal';

const FeedbackCard: React.FC<{ feedback: Feedback; index: number }> = ({
  feedback,
  index,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const formatDate = (timestamp: number) => {
    return new Intl.DateTimeFormat('en-US', {
      month: 'short',
      day: 'numeric',
    }).format(new Date(timestamp));
  };

  return (
    <>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: index * 0.1 }}
        className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-4 
                   transform hover:scale-105 transition-transform duration-200 
                   border border-gray-100 dark:border-gray-700 w-72 cursor-pointer"
        onClick={() => setIsModalOpen(true)}
      >
        {/* Your existing card content */}
        <div className="flex items-start space-x-3">
          <div
            className="w-10 h-10 rounded-full flex items-center justify-center text-white text-sm font-bold shrink-0"
            style={{ backgroundColor: feedback.avatarColor }}
          >
            {feedback.nickname.charAt(0).toUpperCase()}
          </div>

          <div className="min-w-0">
            <div className="flex justify-between items-start">
              <div className="truncate">
                <h3 className="font-semibold text-base text-gray-900 dark:text-gray-100 truncate">
                  {feedback.nickname}
                </h3>
                <p className="text-xs text-gray-600 dark:text-gray-400 truncate">
                  {feedback.position}
                  {feedback.company && ` @ ${feedback.company}`}
                </p>
              </div>
              <span className="text-xs text-gray-500 dark:text-gray-500 ml-2 shrink-0">
                {formatDate(feedback.createdAt)}
              </span>
            </div>

            {feedback.location && (
              <p className="text-xs text-gray-500 dark:text-gray-500 mt-1">
                📍 {feedback.location}
              </p>
            )}

            <p className="mt-2 text-sm text-gray-700 dark:text-gray-300 line-clamp-3">
              {feedback.text}
            </p>
          </div>
        </div>
      </motion.div>

      <ContentModal
        feedback={feedback}
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
};

export default FeedbackCard;
